import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _ from 'lodash';

var log = require('loglevel').getLogger('socket-helper');

var sessionId = document.getElementById('sessionId') ? document.getElementById('sessionId').innerHTML : '';

var CustomSocket = /*#__PURE__*/function () {
  function CustomSocket(url, id, userName, alarmLevels) {
    _classCallCheck(this, CustomSocket);

    this.events = [];
    this.url = url;
    this.id = id;
    this.userName = userName;
    this.alarmLevels = alarmLevels;
    this.socket = null;
    this.connect();
  }

  _createClass(CustomSocket, [{
    key: "onOpen",
    value: function onOpen() {
      log.info("Websocket connection opened: ".concat(this.socket.url));
      var id = this.id,
          userName = this.userName,
          alarmLevels = this.alarmLevels;
      this.send({
        sessionId: sessionId,
        id: id,
        userName: userName,
        alarmLevels: alarmLevels
      });
    }
  }, {
    key: "onError",
    value: function onError() {
      log.error("Websocket connection error: ".concat(this.socket.url));
      this.socket.close();
    }
  }, {
    key: "onClose",
    value: function onClose(event) {
      var _this = this;

      log.info("Websocket connection closed: ".concat(this.socket.url, " with code ").concat(event.code, ". Reconnect will be attempted in 1 second."));
      setTimeout(function () {
        _this.connect();
      }, 1000);
    }
  }, {
    key: "onMessage",
    value: function onMessage(message) {
      log.info("Websocket received message on ".concat(this.socket.url), message.data);
      var data = JSON.parse(message.data);
      if (data.title) return this.events.filter(function (e) {
        return e.pushType === 'message';
      }).forEach(function (e) {
        e.callback(data);
      });
      return this.events.filter(function (e) {
        return e.pushType === 'event';
      }).forEach(function (e) {
        e.callback(data);
      });
    } // onMessage(message) {
    //     log.info(`Websocket received message on ${this.socket.url}`, message.data)
    //     const {pushType, data} = JSON.parse(message.data)
    //     this.events
    //         .filter(event => event.pushType === pushType)
    //         .forEach(event => {
    //             event.callback(data)
    //         })
    // }

  }, {
    key: "on",
    value: function on(pushType, callback, data) {
      var eventObj = {
        pushType: pushType,
        callback: callback,
        data: data
      };
      return this.events.push(eventObj);
    }
  }, {
    key: "off",
    value: function off(pushType, data) {
      return _.remove(this.events, function (e) {
        return e.pushType == pushType && _.isEqual(e.data, data);
      });
    }
  }, {
    key: "connect",
    value: function connect() {
      this.socket = new WebSocket(this.url);
      this.socket.addEventListener('message', this.onMessage.bind(this));
      this.socket.addEventListener('open', this.onOpen.bind(this));
      this.socket.addEventListener('error', this.onError.bind(this));
      this.socket.addEventListener('close', this.onClose.bind(this));
    }
  }, {
    key: "send",
    value: function send(json) {
      log.info("Websocket message send: ".concat(JSON.stringify(json)));
      this.socket.send(JSON.stringify(json));
    }
  }]);

  return CustomSocket;
}();

export { CustomSocket as default };